<template>
  <div class="flex flex-col gap-1.5 text-sm">
    <div v-for="day in days" :key="day.key" class="timeslot-row flex gap-4">
      <span class="w-24 flex-shrink-0 text-gray-600">{{ day.name }}</span>
      <span
        v-if="day.slots.length"
        class="flex-1 grid grid-cols-2 gap-x-4 gap-y-0.5"
      >
        <span
          v-for="(slot, index) in day.slots"
          :key="index"
          class="timeslot whitespace-nowrap"
        >
          {{ slot }}
        </span>
      </span>
      <span v-else class="flex-1 text-gray-500">gesloten</span>
    </div>
  </div>
</template>

<script>
import dateFns from '@/utils/data'

export default {
  name: 'Timeslots',
  props: {
    timeslots: {
      type: Object,
      required: true
    }
  },
  computed: {
    // Monday to Sunday; a day without slots is closed (Sunday is 0 or 7)
    days() {
      const keys = Object.keys(this.timeslots).map((key) => parseInt(key))
      if (!keys.length) return []
      const sunday = keys.includes(7) ? 7 : 0
      return [1, 2, 3, 4, 5, 6, sunday].map((key) => ({
        key,
        name: this.getDay(key).toLowerCase(),
        slots: (this.timeslots[key] || []).map(
          (slot) => `${slot.startTime} – ${slot.endTime}`
        )
      }))
    }
  },
  methods: {
    getDay(d) {
      return dateFns.daysOfWeek.find((day) => day.key === d)?.value || ''
    }
  }
}
</script>
